"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterpriseCluster_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EnterpriseLocation_1 = require("./EnterpriseLocation");
var EnterpriseCluster_Factory = /** @class */ (function () {
    function EnterpriseCluster_Factory() {
    }
    EnterpriseCluster_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ClusterId: model.ClusterId,
            ClusterName: model.ClusterName,
            EnterpriseLocations: model.EnterpriseLocations && model.EnterpriseLocations.map(function (i) { return EnterpriseLocation_1.EnterpriseLocation_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    EnterpriseCluster_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ClusterId: model.ClusterId,
            ClusterName: model.ClusterName,
            EnterpriseLocations: model.EnterpriseLocations && model.EnterpriseLocations.map(function (i) { return EnterpriseLocation_1.EnterpriseLocation_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return EnterpriseCluster_Factory;
}());
exports.EnterpriseCluster_Factory = EnterpriseCluster_Factory;
